<template>
  <div class="detail">
    <Head></Head>
    <Body></Body>
    <Content></Content>
    <Slide></Slide>
    <Fotter></Fotter>
  </div>
</template>
<script>
import Head from '../components/detail/header'
import Body from '../components/detail/body1'
import Content from '../components/detail/content'
import Slide from '../components/detail/slide1'
import Fotter from '../components/index/fotter'

import '../../public/PLupload/lib/crypto1/crypto/crypto.js'
import '../../public/PLupload/lib/crypto1/hmac/hmac.js'
import '../../public/PLupload/lib/crypto1/sha1/sha1.js'
import '../../public/PLupload/lib/base64.js'
import plupload from 'plupload'

let accessid = 'LTAIKIMZYqT7o3sd'
let accesskey = 'bOqt3eOIbDRYkaDIgb84Q8dKyJF6fT'
let host = 'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com'

let g_dirname = ''
let g_object_name = ''
let g_object_name_type = ''
let timestamp
let now = (timestamp = Date.parse(new Date()) / 1000)
let pos = ''
let suffix = ''

const baseUlr = window.location.host
const url = !baseUlr.includes('192')
  ? 'https://' + baseUlr
  : 'https://www.yunshanyin.net'

var policyText = {
  expiration: '2030-05-01T12:00:00.000Z', // 设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
  conditions: [
    ['content-length-range', 0, 104857600000000] // 设置上传文件的大小限制
  ]
}
var policyBase64 = window.Base64.encode(JSON.stringify(policyText))
let message = policyBase64
var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true })
var signature = Crypto.util.bytesToBase64(bytes)

function check_object_radio() {
  var tt = document.getElementsByName('myradio')
  for (var i = 0; i < tt.length; i++) {
    if (tt[i].checked) {
      g_object_name_type = tt[i].value
      break
    }
  }
}
function check_object_radio2() {
  var tt = document.getElementsByName('myradio2')
  for (var i = 0; i < tt.length; i++) {
    if (tt[i].checked) {
      g_object_name_type = tt[i].value
      break
    }
  }
}
function get_dirname() {
  let dir = document.getElementById('dirname').value
  if (dir != '' && dir.indexOf('/') != dir.length - 1) {
    dir = dir + '/'
  }
  g_dirname = dir
}
function get_dirname2() {
  let dir = document.getElementById('dirname2').value
  if (dir != '' && dir.indexOf('/') != dir.length - 1) {
    dir = dir + '/'
  }
  g_dirname = dir
}

function random_string(len, filename) {
  // len = len || 32;
  // var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  // var maxPos = chars.length;
  // var pwd = '';
  // for (i = 0; i < len; i++) {
  //     pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  // }
  let pwd = filename

  return pwd
}

function get_suffix(filename) {
  pos = filename.lastIndexOf('.')
  suffix = ''
  if (pos != -1) {
    suffix = filename.substring(pos)
  }

  return suffix
}

function calculate_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    g_object_name += '${filename}'
  } else if (g_object_name_type == 'random_name') {
    suffix = get_suffix(filename)
    g_object_name = g_dirname + random_string(10, filename)
  }
  return ''
}

function get_uploaded_object_name(filename) {
  if (g_object_name_type == 'local_name') {
    tmp_name = g_object_name
    tmp_name = tmp_name.replace('${filename}', filename)
    return tmp_name
  } else if (g_object_name_type == 'random_name') {
    return g_object_name
  }
}

function set_upload_param(up, filename, ret) {
  g_object_name = g_dirname
  if (filename != '') {
    suffix = get_suffix(filename)
    calculate_object_name(filename)
  }
  let new_multipart_params = {
    key: g_object_name,
    policy: policyBase64,
    OSSAccessKeyId: accessid,
    success_action_status: '200', // 让服务端返回200,不然，默认会返回204
    signature: signature
  }

  up.setOption({
    url: host,
    multipart_params: new_multipart_params
  })

  up.start()
}

function upit(index, el) {
  let uploader = new plupload.Uploader({
    id: index,
    runtimes: 'html5,flash,silverlight,html4',
    browse_button: el,
    // multi_selection: false,
    flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
    // chunk_size: 1024 * 1024 * 5, 是否分片上传
    silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
    url: 'http://oss.aliyuncs.com',
    filters: {
      mime_types: [
        // 限制可上传的文件格式
        { title: 'Image files', extensions: 'jpg' },
        { title: 'Zip files', extensions: 'zip' },
        { title: 'Rar files', extensions: 'rar' },
        { title: 'Cdr files', extensions: 'cdr' }
      ]
    },
    init: {
      PostInit: function() {
        $('.ossfile')
          .eq(index)
          .text('')
      },

      FilesAdded: function(up, files) {
        window.Fname = $(el)
          .parents('.f')
          .siblings('.title')
          .find('.check')[0]
        set_upload_param(uploader, '', false)

        plupload.each(files, function(file) {
          let ossFile = $(el)
            .parents('.contaniner')
            .siblings('.ossfile')
          ossFile.html(
            '<div id="' +
              file.id +
              '">' +
              file.name +
              ' (' +
              plupload.formatSize(file.size) +
              ')<b></b>' +
              '<div class="progress"><div class="progress-bar" style="width: 0%;"></div></div>' +
              '</div>'
          )
        })
      },

      BeforeUpload: function(up, file) {
        check_object_radio()
        get_dirname()
        set_upload_param(up, file.name, true)
      },

      UploadProgress: function(up, file) {
		
        var d = document.getElementById(file.id)
        d.getElementsByTagName('b')[0].innerHTML =
          '<span>' + file.percent + '%</span>'
        var prog = d.getElementsByTagName('div')[0]
        var progBar = prog.getElementsByTagName('div')[0]
        progBar.style.width = 2.9 * file.percent + 'px'
        progBar.setAttribute('aria-valuenow', file.percent)
      },

      FileUploaded: function(up, file, info) {
        if (info.status == 200) {
          let shoppingCarId = $(el)
            .parents('.contaniner')
            .attr('id')

          let filenamee =
            'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com/' +
            get_uploaded_object_name(file.name)
          $.ajax({
            type: 'post',
            url: url + '/api/car/editcar',
            data: { id: shoppingCarId, filename: filenamee, file: file.name },
            dataType: 'json',
            success: function(res) {
              if (res.code == 1) {
                $(el).text('替换文件')
                $(el).addClass('c')
                $(el)
                  .parents('.contaniner')
                  .siblings('.ossfile')
                  .find('.progress')
                  .hide()
                $(el)
                  .parents('.f')
                  .siblings('.title')
                  .find('.check')
                  .prop('checked', 'true')
                $('#allProducts').click()
              } else {
                alert('上传失败!')
              }
            }
          })
        } else {
          alert('上传出错了')
        }
      },

      Error: function(up, err) {
        alert('出错了！')
        window.location.reload()
      }
    }
  })

  uploader.init()
}
function upit2(index, el) {
  let uploader = new plupload.Uploader({
    id: index,
    runtimes: 'html5,flash,silverlight,html4',
    browse_button: el,
    // multi_selection: false,
    flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
    // chunk_size: 1024 * 1024 * 5, 是否分片上传
    silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
    url: 'http://oss.aliyuncs.com',
    filters: {
      mime_types: [
        // 限制可上传的文件格式
        { title: 'Image files', extensions: 'jpg' },
        { title: 'Zip files', extensions: 'zip' },
        { title: 'Rar files', extensions: 'rar' },
        { title: 'Cdr files', extensions: 'cdr' }
      ]
    },
    init: {
      PostInit: function() {
        $('.ossfile')
          .eq(index)
          .text('')
      },

      FilesAdded: function(up, files) {
        window.Fname = $(el)
          .parents('.f')
          .siblings('.title')
          .find('.check')[0]
        set_upload_param(uploader, '', false)

        plupload.each(files, function(file) {
          let ossFile = $('.ossfile')
          ossFile.html(
            '<div id="' +
              file.id +
              '">' +
              file.name +
              ' (' +
              plupload.formatSize(file.size) +
              ')<b></b>' +
              '<div class="progress"><div class="progress-bar" style="width: 0%;"></div></div>' +
              '</div>'
          )
        })
      },

      BeforeUpload: function(up, file) {
        check_object_radio2()
        get_dirname2()
        set_upload_param(up, file.name, true)
      },

      UploadProgress: function(up, file) {
		
        var d = document.getElementById(file.id)
       
		  if(file.percent ==100){
			  d.getElementsByTagName('b')[0].innerHTML =
			    '<span style ="color:#01db23">' + file.percent + '%</span>'
		  }else{
			  d.getElementsByTagName('b')[0].innerHTML =
			    '<span>' + file.percent + '%</span>'
		  }
        var prog = d.getElementsByTagName('div')[0]
        var progBar = prog.getElementsByTagName('div')[0]
        progBar.style.width = 2.9 * file.percent + 'px'
		 if(file.percent ==100){
			
			 progBar.style.backgroundColor = '#01db23'
		}
        progBar.setAttribute('aria-valuenow', file.percent)
      },

      FileUploaded: function(up, file, info) {
        if (info.status == 200) {
			$('input[name="fileurl"]').val('https://yunshanyin.oss-cn-shenzhen.aliyuncs.com/' +
            get_uploaded_object_name(file.name)) 	
            
          console.log(file,up,info)
        } else {
			$('input[name="fileurl"]').val('')
          alert('上传出错了')
        }
      },

      Error: function(up, err) {
        alert('出错了！')
        window.location.reload()
      }
    }
  })

  uploader.init()
}
export default {
  components: {
    Head,
    Body,
    Content,
    Slide,
    Fotter
  },
  methods: {
    initUpload() {}
  },
  mounted() {
    $('.addcar').click(function() {
      $('#shopCart').click()
    })
    var count = 0
    $('#shopCart').click(function() {
      if (count <= 0) {
        setTimeout(() => {
          $.each($('.item #selectfiles'), function(
            indexInArray,
            valueOfElement
          ) {
            upit(indexInArray, valueOfElement)
          })
        }, 700)
      } else {
        setTimeout(() => {
          let scBtn = '.item #selectfiles'
          upit($(scBtn).length - 1, $(scBtn).eq($(scBtn).length - 1)[0])
        }, 700)
      }
      count++
    })
	
	
	 upit2(0, $('#addOrderFile').eq(0)[0])
  }
}
</script>

<style lang="less" scoped>
</style>
